module.exports = __webpack_public_path__ + "static/banner-1110x180.jpg";